import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useNotifications } from "../../context/NotificationContext";
import { Bell, Store, LogOut } from "lucide-react";
import { toast } from "sonner";

export function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { counts, setPanelOpen } = useNotifications();
  const notifCount = counts?.total || 0;
  const initial = (user?.name || "?").charAt(0).toUpperCase();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success("Signed out");
    } catch (_e) {
      // logout() always redirects; nothing meaningful to surface.
    }
  };

  return (
    <header
      data-testid="vc-header"
      className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-100 px-4 py-3 lg:hidden"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-emerald-500 to-emerald-600 grid place-items-center shrink-0 shadow-sm">
            <Store className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="min-w-0">
            <h1 data-testid="vc-header-title" className="text-[15px] font-bold text-slate-900 leading-tight truncate">
              KonexoCRM
            </h1>
            <p className="text-xs text-slate-500 leading-tight truncate">
              Business Connected
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <button
            data-testid="vc-header-notif"
            onClick={() => setPanelOpen(true)}
            className="relative w-10 h-10 rounded-full grid place-items-center text-slate-600 hover:bg-slate-100 transition"
            aria-label="Notifications"
          >
            <Bell className="w-5 h-5" strokeWidth={2} />
            {notifCount > 0 && (
              <span
                data-testid="vc-header-notif-badge"
                className="absolute top-1.5 right-1.5 min-w-[16px] h-[16px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center"
              >
                {notifCount > 9 ? "9+" : notifCount}
              </span>
            )}
          </button>
          <button
            data-testid="vc-header-avatar"
            onClick={() => navigate("/settings")}
            className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-100 to-indigo-200 text-indigo-700 grid place-items-center font-bold text-sm shadow-sm hover:shadow transition"
            aria-label="Profile"
          >
            {initial}
          </button>
          <button
            data-testid="vc-header-logout"
            onClick={handleLogout}
            className="w-10 h-10 rounded-full grid place-items-center text-slate-600 hover:bg-red-50 hover:text-red-600 transition"
            aria-label="Log out"
            title="Log out"
          >
            <LogOut className="w-5 h-5" strokeWidth={2} />
          </button>
        </div>
      </div>
    </header>
  );
}
